
      // 捕获模块加载错误
      try {
        // 动态导入主模块
        import('/src/main.ts')
          .catch(error => {
            console.error('模块加载失败:', error);
            const errorEl = document.getElementById('app-error');
            if (errorEl) {
              errorEl.style.display = 'block';
              errorEl.innerHTML = `
                <strong>模块加载失败</strong><br>
                <small>${error.message}</small><br>
                <small>请尝试清除浏览器缓存后刷新页面</small>
              `;
            }
            // 显示回退按钮
            showFallbackButton();
          });
      } catch(e) {
        console.error('ES模块加载异常:', e);
        // 尝试使用备用加载方式
        useLegacyLoader();
      }
    